import React from 'react';
import { View, StyleSheet, ViewStyle, StyleProp } from 'react-native';
import Card from './Card';
import Text from './Text';
import { Theme } from '../../utils/theme';

interface OptionCardProps {
  label: string;
  icon?: string;
  description?: string;
  selected?: boolean;
  onPress: () => void;
  disabled?: boolean;
  style?: StyleProp<ViewStyle>;
  showCheckmark?: boolean;
}

export default function OptionCard({
  label,
  icon,
  description,
  selected = false,
  onPress,
  disabled = false,
  style,
  showCheckmark = true,
}: OptionCardProps) {
  return (
    <Card
      onPress={onPress}
      variant={selected ? 'elevated' : 'default'}
      disabled={disabled}
      style={[styles.container, style]}
    >
      <View style={styles.content}>
        {icon && (
          <Text variant="heading2" style={styles.icon}>
            {icon}
          </Text>
        )}
        
        <View style={styles.textContainer}>
          <Text variant="body1" color="primary" style={styles.label}>
            {label}
          </Text>
          
          {description && (
            <Text variant="body2" color="secondary" style={styles.description}>
              {description}
            </Text>
          )}
        </View>
        
        {showCheckmark && selected && (
          <Text variant="body1" color="primary" style={styles.checkmark}>
            ✓
          </Text>
        )}
      </View>
    </Card>
  );
}

const styles = StyleSheet.create({
  container: {
    padding: Theme.spacing.xxl,
    backgroundColor: Theme.colors.surface,
    borderWidth: 1,
    borderColor: Theme.colors.border,
  },
  content: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: Theme.spacing.lg,
  },
  icon: {
    fontSize: 24,
  },
  textContainer: {
    flex: 1,
    gap: Theme.spacing.xs,
  },
  label: {
    flex: 1,
  },
  description: {
    fontSize: 14,
    lineHeight: 18,
  },
  checkmark: {
    fontSize: 18,
    color: Theme.colors.primary,
    fontWeight: 'bold',
  },
}); 